
<ng-container *ngIf="loading">
    <div class="container-with-loading">
        <div class="loading-overlay">
            <mat-spinner></mat-spinner>
        </div>
    </div>
</ng-container>
  
<mat-card class="offer-card" appearance="outlined" [hidden]="loading">
    <!--mat-card-header>
        <mat-card-title>Beneficio</mat-card-title>
	</mat-card-header-->
	<mat-card-content>

		<form class="form-container" (ngSubmit)="onSubmitBenefir(variableGroupForm)" #variableGroupForm="ngForm" >

			<mat-card class="general-wf-card" appearance="outlined">
				<!--mat-card-header>
					<mat-card-title>{{title}}</mat-card-title>
				</mat-card-header-->
				<mat-card-content>
					<div id="container" class="formControl">
					
						<div class="control">
							<mat-form-field class="controlWidth">
								<mat-label>Descripci&oacute;n</mat-label>
								<input type="text" matInput name="variable.description" [(ngModel)]="variable.description">
								<mat-error>{{ violations['variable.description'] }}</mat-error>
							</mat-form-field>
						</div>
						<div class="control">
							<mat-form-field class="controlWidth">
								<mat-label>C&oacute;digo</mat-label>
								<input type="text" matInput name="variable.attribute" [(ngModel)]="variable.attribute" (keydown.space)="$event.preventDefault()">
								<mat-error>{{ violations['variable.attribute'] }}</mat-error>
							</mat-form-field>
						</div>
                        <!--div class="control">
                            <mat-form-field class="controlWidth">
                              <mat-label>Tipo Beneficio</mat-label>
                              <mat-select [(ngModel)]="variable.variableType"  [compareWith]="compareVariableTypes" name="variable.variableType" >
                              @for (variableType of variableTypes ; track variableType.id) {
                                <mat-option [value]="variableType">{{ variableType.description }}</mat-option>
                              }
                            </mat-select>
							<mat-error>{{ violations['variable.variableType'] }}</mat-error>
							<mat-error *ngIf="violations['variable.variableType']">
								{{ violations['variable.variableType'] }}
							  </mat-error>
                            </mat-form-field>
                        </div-->
						<div class="control">
							<mat-slide-toggle [(ngModel)]="variable.active"  name="variableActive" > 
							  {{ variable.active? 'Beneficio Activo':'Beneficio Inactivo'}} 
							</mat-slide-toggle>
						</div>
					</div>
				</mat-card-content>
			</mat-card>
			<div class="formControl">
				<div class="control">
					<button mat-flat-button class="button buttonWidth">
					  {{(variable.id > 0)? 'Actualizar': 'Guardar'}}
					</button>
				</div>
			</div>
		</form>
	</mat-card-content>
</mat-card>